import dayjs from "@eisox/dayjs";
import { Alert } from "@eisox/design-system";
import { ArrowRightIcon } from "@eisox/icons";

import { applySlot, type HeatingNetworkFrostFreeSlots } from "~/features/frost-free/helpers/actions.helper";
import type {
  FrostFreeHeatingNetworkResult,
  FrostFreePlannedHeatingNetworkResult,
  HeatingNetworkFrostFreeSource,
} from "~/features/frost-free/helpers/status.helper";
import { FrostFreeSource } from "~/features/frost-free/helpers/status.helper";
import { m } from "~/paraglide/messages";

const LABEL_BY_SOURCE: Record<HeatingNetworkFrostFreeSource, () => string> = {
  [FrostFreeSource.BUILDING]: m.frost_free_activated,
  [FrostFreeSource.HEATING_NETWORK]: m.frost_free_activated_by_network,
  [FrostFreeSource.ROOMS_ALL]: m.frost_free_activated_by_all_rooms,
};

interface ActiveProps {
  result: FrostFreeHeatingNetworkResult;
  slots: HeatingNetworkFrostFreeSlots;
  className?: string;
}

const Active: React.FC<ActiveProps> = ({ result, slots, className }) => {
  if (!result.active) return null;

  const alert = (
    <Alert className={className}>
      <p className="flex flex-col items-center">
        {LABEL_BY_SOURCE[result.source]()}
        {result.period && (
          <span>
            {dayjs(result.period.begin).format("L")} - {dayjs(result.period.end).format("L")}
          </span>
        )}
      </p>
      <ArrowRightIcon />
    </Alert>
  );

  return <>{applySlot(result.source, alert, slots)}</>;
};

Active.displayName = "HeatingNetworkFrostFreeAlert.Active";

interface PlannedProps {
  result: FrostFreePlannedHeatingNetworkResult;
  slots: HeatingNetworkFrostFreeSlots;
  className?: string;
}

const Planned: React.FC<PlannedProps> = ({ result, slots, className }) => {
  if (!result.planned) return null;

  const alert = (
    <Alert className={className}>
      {m.frost_free_planned()}
      <ArrowRightIcon />
    </Alert>
  );

  return <>{applySlot(result.source, alert, slots)}</>;
};

Planned.displayName = "HeatingNetworkFrostFreeAlert.Planned";

export const HeatingNetworkFrostFreeAlert = { Active, Planned };
